module.exports = __webpack_public_path__ + "dimer/static/img/4.625ec8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/4.jpg
// module id = 6Msz
// module chunks = 0